import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";

const platform = Capacitor.getPlatform();
const platformIconClass =
  platform === "ios" ? "fab fa-apple" :
    platform === "android" ? "fab fa-android" :
      Utils.IsAppInstalled() ? "fas fa-mobile-alt" : "fas fa-globe"; // web: installed PWA vs plain browser tab

const PlatformVersionInfo = () => {
  const { useAppSelector } = useRedux();
  const appUpdateInfo = useAppSelector((state: any) => state.Settings.appUpdateInfo);
  const [appVersionDisplay, setAppVersionDisplay] = useState(Utils.APP_VERSION.replaceAll("?v=", ""));
  useEffect(() => {
    Utils.GetDisplayAppVersion().then(setAppVersionDisplay);
  }, []);

  const hasUpdate = appUpdateInfo?.isuptodate === false;

  return (
    <span>
      <i className={platformIconClass}></i>&nbsp;v{appVersionDisplay}
      {hasUpdate && (
        <span
          className={appUpdateInfo?.forceupdate ? "text-danger ms-2" : "text-primary ms-2"}
          style={{ cursor: "pointer" }}
          onClick={Utils.GoToAppStore}
          title={appUpdateInfo?.shortinfo || "มีอัปเดตใหม่ - คลิกเพื่อไปที่สโตร์"}
        >
          <i className="mdi mdi-update"></i>
          {appUpdateInfo?.versioncode ? ` ใหม่ v${appUpdateInfo.versioncode}` : " ใหม่"}
        </span>
      )}
    </span>
  );
};

export default PlatformVersionInfo;
